import {filter, gt, lt} from 'ramda';
import {isNumber} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

export const filterByMinMax = (min: number | Nullish, max: number | Nullish) =>
  filter<number>(
    (value) => !((isNumber(min) && lt(value, min)) || (isNumber(max) && gt(value, max)))
  );
